"use client";

import { useEffect } from "react";

/* Era dentro components/article/DispaccioView.tsx (spalla e coda del
   dispaccio); dal 26/10/2026 lo usa anche la colonna destra delle pagine dei
   nodi (components/corridoi/pagina/ColonnaAnnunci.tsx). `chiave`: quando
   cambia l'insieme delle schede (un nuovo sorteggio) si rimisura. */

/** Mostra, delle schede dentro `scatola`, solo quelle che ci stanno intere.
 *  La scatola è `relative flex-1`, dentro un livello `absolute inset-0`
 *  con le schede: l'altezza la decide la colonna accanto, non loro.
 *  Si nasconde la prima scheda che sfora e si rimisura, finché tutte
 *  stanno: le successive salgono, e una più piccola entra dove la grande
 *  non entrava. Una scheda con righe `data-riga` (la tabella dei report)
 *  prima si accorcia dal fondo, fino a tre righe. Gira al
 *  montaggio, quando arrivano i caratteri e a ogni cambio d'altezza. */
export function useRiempiVuoto(scatola: { current: HTMLDivElement | null }, chiave?: unknown) {
  useEffect(() => {
    const box = scatola.current;
    if (!box) return;
    const lista = box.firstElementChild as HTMLElement | null;
    if (!lista) return;
    const adatta = () => {
      const voci = [...lista.children] as HTMLElement[];
      voci.forEach((v) => {
        v.style.display = "";
        v.querySelectorAll<HTMLElement>("[data-riga]").forEach((r) => (r.style.display = ""));
      });
      // Solo se il livello delle schede è sopra la scatola (`absolute`): sotto
      // i 900 pixel la colonna dei nodi le mette in flusso, e lì la scatola è
      // alta quanto loro; misurarla toglieva l'ultima scheda per un pixel di
      // arrotondamento (offsetTop/offsetHeight sono interi).
      if (getComputedStyle(lista).position !== "absolute") return;
      // L'altezza utile è quella del livello delle schede, non della
      // scatola: di solito coincidono (`inset-0`), ma il livello può partire
      // più in basso per tenere dentro lo stacco (`RiempiTesto staccoDentro`).
      const alto = lista.clientHeight + 1;
      const sfora = (v: HTMLElement) => v.style.display !== "none" && v.offsetTop + v.offsetHeight > alto;
      // Si toglie una scheda per volta, la prima che sfora, e si rimisura:
      // quelle dopo salgono e una più piccola può entrare dove la grande
      // non entrava (la striscia di rimandi in coda chiude il bianco).
      for (let giro = 0; giro < voci.length; giro++) {
        const v = voci.find(sfora);
        if (!v) return;
        const righe = [...v.querySelectorAll<HTMLElement>("[data-riga]")].filter((r) => r.style.display !== "none");
        let restano = righe.length;
        while (sfora(v) && restano > 3) righe[--restano].style.display = "none";
        if (sfora(v)) v.style.display = "none";
      }
    };
    adatta();
    const ro = new ResizeObserver(adatta);
    ro.observe(box);
    document.fonts?.ready.then(adatta);
    return () => ro.disconnect();
  }, [scatola, chiave]);
}

